import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, IdCard } from "lucide-react";
import InnerHero from "../components/InnerHero";

const ieiFacultyMembers = [
  {
    name: "Dr. V. A. Kulkarni",
    branch: "Electrical & Electronics Engineering",
    membership: "AM-093020-5",
  },
  { name: "Deepak V Lokare", branch: "Mechanical Engineering", membership: "M-1697425" },
  { name: "Dr. K S Pujar", branch: "Mechanical Engineering", membership: "M-143934-3" },
  { name: "Ranganath N. Patil", branch: "Mechanical Engineering", membership: "M-149377-3" },
  { name: "G. R. Sattigeri", branch: "Mechanical Engineering", membership: "M-150713-8" },
  { name: "S. D. Kulkarni", branch: "Mechanical Engineering", membership: "F-120258-4" },
  { name: "G. H. Joshi", branch: "Mechanical Engineering", membership: "M-1697417" },
  { name: "B. B. Patil", branch: "Mechanical Engineering", membership: "M-143931-9" },
  { name: "Chandrakant M.T.", branch: "Mechanical Engineering", membership: "M-1697395" },
  { name: "R. J. Talapati", branch: "Mechanical Engineering", membership: "M-1697441" },
  { name: "D. V. Lokare", branch: "Mechanical Engineering", membership: "M-1697425" },
  { name: "S. N. Badiger (Amie)", branch: "Mechanical Engineering", membership: "ST-466267-4" },
  { name: "Anant Joshi", branch: "Mechanical Engineering", membership: "M-1697573" },
  { name: "Gururaj Hatti", branch: "Mechanical Engineering", membership: "M-1675265" },
  { name: "Santosh Savanur", branch: "Mechanical Engineering", membership: "M-1697549" },
  { name: "Gurunath M", branch: "Mechanical Engineering", membership: "M-1697433" },
  { name: "Naveen Hiremath", branch: "Mechanical Engineering", membership: "M-1697514" },
  { name: "Dr. Ashik Bellary", branch: "Civil Engineering", membership: "AM-3046470" },
  { name: "S. G. Hiremath", branch: "Civil Engineering", membership: "M-149389-7" },
  { name: "Harsha Jadhav", branch: "Civil Engineering", membership: "M-1697352" },
  { name: "Laxmi G Hattiholi", branch: "Civil Engineering", membership: "M-1697409" },
  { name: "Vijayalaxmi V", branch: "Civil Engineering", membership: "M-1697484" },
  { name: "Hushayardhan V S", branch: "Civil Engineering", membership: "M-1697859" },
  { name: "Seema B", branch: "Civil Engineering", membership: "M-1697832" },
  {
    name: "A V Kolaki",
    branch: "Electronics & Communication Engineering",
    membership: "M-149380-3",
  },
  {
    name: "Dr. Arun L. Kakhandki",
    branch: "Electronics & Communication Engineering",
    membership: "AM-094148-7",
  },
  {
    name: "Dr. Nagendra M. Pujari",
    branch: "Electronics & Communication Engineering",
    membership: "G-547734-5",
  },
  {
    name: "Plasin F. Dias",
    branch: "Electronics & Communication Engineering",
    membership: "M-1493811",
  },
  {
    name: "Nikhil Kulkarni",
    branch: "Electronics & Communication Engineering",
    membership: "M-1697476",
  },
  {
    name: "Rohini Kallur",
    branch: "Electronics & Communication Engineering",
    membership: "M-1697557",
  },
  {
    name: "Raghavendra. N",
    branch: "Electronics & Communication Engineering",
    membership: "M-1697611",
  },
  {
    name: "Suraj Kadli",
    branch: "Electronics & Communication Engineering",
    membership: "M-1697727",
  },
  {
    name: "Dr. Nagaraj D. Bhat",
    branch: "Electronics & Communication Engineering",
    membership: "AM-1957468",
  },
  {
    name: "Vataprasad Gaonkar",
    branch: "Electrical & Electronics Engineering",
    membership: "M-1697824",
  },
  {
    name: "Subrahmanya Hegde",
    branch: "Electrical & Electronics Engineering",
    membership: "M-1697735",
  },
  {
    name: "Ravindra Motekar",
    branch: "Electrical & Electronics Engineering",
    membership: "M-169923",
  },
  {
    name: "Mrs. Rajeshwari Naganavar",
    branch: "Electrical & Electronics Engineering",
    membership: "M-1697625",
  },
  {
    name: "Jayashree Shedbalkar",
    branch: "Computer Science & Engineering",
    membership: "M-149387-0",
  },
  {
    name: "Dr. Poornima Raikar",
    branch: "Computer Science & Engineering",
    membership: "M-149388-9",
  },
  {
    name: "Mrs. Farzana Nadaf",
    branch: "Computer Science and Engineering",
    membership: "M-1697765",
  },
  {
    name: "Mrs. Suman Yaligar",
    branch: "Computer Science and Engineering",
    membership: "AM3129783",
  },
];

const IEINav = () => (
  <section className="bg-surface-alt/60 border-b border-brand/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap gap-x-6 gap-y-2 text-xs font-sans-ui font-semibold tracking-wider text-brand">
      <Link to="/associations/iei" className="uppercase hover:underline">
        Overview
      </Link>
      <Link to="/associations/iei#achievements" className="uppercase hover:underline">
        Achievements
      </Link>
      <Link to="/associations/iei/activities" className="uppercase hover:underline">
        Activities
      </Link>
      <Link to="/associations/iei/faculty-members" className="uppercase hover:underline">
        Faculty Members
      </Link>
      <Link to="/associations/iei#student" className="uppercase hover:underline">
        Student Members
      </Link>
    </div>
  </section>
);

const IEIFacultyMembers = () => {
  return (
    <main>
      <InnerHero
        title="IEI Faculty Members"
        image="https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?w=2400"
        breadcrumbs={[
          { label: "Associations & Innovation Hub", to: "/associations" },
          { label: "IEI", to: "/associations/iei" },
          { label: "Faculty Members" },
        ]}
      />

      <IEINav />

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <Link
          to="/associations/iei"
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:underline mb-8"
        >
          <ArrowLeft size={16} />
          Back to IEI
        </Link>

        <div className="bg-white border border-brand/15">
          <div className="p-6 md:p-8 border-b border-brand/10">
            <p className="text-xs uppercase tracking-[0.28em] text-brand font-semibold mb-3">
              IEI Faculty Membership
            </p>
            <h1
              className="text-3xl md:text-5xl text-brand font-semibold leading-tight"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Faculty membership details
            </h1>
          </div>

          <div className="grid gap-4 p-6 md:p-8 md:grid-cols-2 xl:grid-cols-3">
            {ieiFacultyMembers.map((member, index) => (
              <article
                key={`${member.name}-${index}`}
                className="min-h-[154px] border border-brand/15 bg-surface-alt/25 p-5 flex flex-col justify-between"
              >
                <div>
                  <h2
                    className="text-xl text-brand font-semibold leading-snug"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {member.name}
                  </h2>
                  <p className="mt-3 text-[15px] leading-relaxed text-[#2a2a2a]/85">
                    {member.branch}
                  </p>
                </div>

                <p className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#2a2a2a]">
                  <IdCard size={15} className="text-brand flex-shrink-0" />
                  <span>{member.membership}</span>
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default IEIFacultyMembers;